<script>
    import {createEventDispatcher} from 'svelte';

    const dispatch = createEventDispatcher(); 

    let mouseDownAction = () => {
		dispatch('mousedown');
	};

    export let isWidget = false;
    export let title = "Title Here";
    export let icon = "ship";
    export let value = 0;
    export let color = ""
    export let active = false;
    export let disabled = false;
</script>

<div class="card clickable filter-card {active === true ? 'active' : ''} {disabled === true ? 'disabled' : ''} {color}" id="queued-card" on:mousedown={mouseDownAction} class:active={active}>
    {#if isWidget}
        <div class="reporting-content">
            <i class="fa fa-{icon}"></i>
            <h3>{title}</h3>
            <h1 class="{color}" id="queued-messages-count">{value}</h1>
        </div>
    {/if}
</div>

<style>
    .card {
        transition: all 0.2s ease-in-out;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0 2px 4px 2px #00aec92a;
        padding: 0.5em;
        border-top: none;
        border-left: none;
        border-right: none;
        border-bottom: 4px solid;
    }

    .disabled{
        pointer-events: none;
    }

    .card i {
        color: var(--grey-300)
    }

    .card.active {
        border: 3px solid var(--blue);
        border-top: 3px solid var(--blue);
        border-left: 3px solid var(--blue);
        border-right: 3px solid var(--blue);
    }

    @media(max-width: 500px){
        .card.active {
            border: 2px solid var(--blue); 
            transform: none;
        }
    }

    @media(max-width: 1600px){
        .reporting-content {
            padding: 6px;
        }

            .reporting-content i {
                font-size: 2.2rem;
            }

            .reporting-content h1 {
                font-size: 2rem;
            }

            .reporting-content h3 {
                margin-top: 12px;
                margin-bottom: 5px;
                font-size: 12px!important;
            }

            .reporting-content h2 {
                font-size: 1rem!important;
            }
    }

.clickable{
    cursor:pointer;
}

.clickable:hover{
    transform: scale(1.05);
    transition: 0.3s ease-in-out;
}

.animated {
    animation: cardEntrance 400ms ease-out;
    animation-fill-mode: backwards;
}

.border {
    border-bottom: 3px solid;
}

#wide {
    grid-column: span 2 / auto;
}

@keyframes cardEntrance {
    from {
        opacity: 0;
        transform: scale(0.3);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

.reporting-content {
    padding: 6px;
}

    .reporting-content i {
        font-size: 2.2rem;
    }

    .reporting-content h1 {
        font-size: 2.2rem;
        font-weight: 600;
    }

    .reporting-content h3 {
        margin-top: 12px;
        margin-bottom: 5px;
        font-size: 16px;
        text-align: initial!important;
        font-weight: 500;
    }

    .card.primary {
        border-color: var(--blue-1);
    }

    .card.secondary {
        border-color: var(--yellow);
    }

    .card.tertiary {
        border-color: var(--grey-500);
    }

    .card.danger {
        border-color: var(--danger-color);
    }

    .card.primary h1{
        color: var(--blue-1);
    }

    .card.secondary h1{
        color: var(--yellow);
    }

    .card.tertiary h1{
        color: var(--grey-500);
    }

    .card.danger h1{
        color: var(--danger-color);
    }

</style>
